// extracted by mini-css-extract-plugin
export default {"design":"Design_design__p4y9U","h1":"Design_h1__3m69v","insideDiv":"Design_insideDiv__DBgXg"};